import { Button, SkeletonLoader, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  border-radius: 8px;
  padding: 16px 20px;
  background-color: var(--surface-default);
  display: flex;
  flex-direction: column;
`;

export const TitleLabel = styled.div`
  ${typographyV2.titleMd};
  padding-bottom: 4px;
`;

export const DescriptionLabel = styled.div`
  ${typographyV2.bodySm};
  padding-bottom: 16px;
`;

export const StyledButton = styled(Button)`
  width: fit-content;
`;

export const StyledLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '128px',
        borderRadius: '8px',
      },
    },
  ],
})``;
